// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/tab-view/tab-view.less
// module id = 2708
// module chunks = 0 1